(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MailingConfigService', MailingConfigService);

  MailingConfigService.$inject = ['$resource'];

 	function MailingConfigService ($resource) {
    return $resource(apiUrl + '/mailing/configs/item/:id', { id: '@id' }, {
      getAllConfigs: { url: apiUrl + '/mailing/configs/get-all', method: 'GET', params: {}, isArray: false },
      saveConfig: { url: apiUrl + '/mailing/configs/save', method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      readFile: { url: apiUrl + '/mailing/configs/read-file', method: 'POST', params: {}, isArray: true },
      loadFields: { url: apiUrl + '/mailing/configs/load-fields', method: 'GET', params: {}, isArray: true },
      cleanFields: { url: apiUrl + '/mailing/configs/clean-fields', method: 'GET', params: {}, isArray: false },
      saveFieldCmd: { url: apiUrl + '/mailing/configs/save-field-cmd', method: 'POST', params: {}, isArray: false }
    });
  }
})();
